import React from 'react';
import { AudioOutlined, CloseOutlined, LoadingOutlined, StopOutlined } from '@ant-design/icons';
import WaveIndicator from './WaveIndicator';

type DictationOverlayProps = {
  open: boolean;
  recording: boolean;
  transcript: string;
  error?: string | null;
  permissionDenied?: boolean;
  onStop: () => void;
  onCancel: () => void;
};

const DictationOverlay: React.FC<DictationOverlayProps> = ({
  open,
  recording,
  transcript,
  error,
  permissionDenied = false,
  onStop,
  onCancel,
}) => {
  if (!open) return null;

  const title = error
    ? permissionDenied
      ? 'Microphone access denied'
      : 'Dictation unavailable'
    : recording
      ? 'Listening…'
      : 'Preparing dictation…';

  const subtitle = error
    ? permissionDenied
      ? 'Allow microphone access in your browser settings, then try again.'
      : error
    : recording
      ? 'Speak now — recording in progress'
      : 'Please wait while we start recording.';

  return (
    <div className="praxys-dictation-overlay" role="dialog" aria-modal="true" aria-label="Dictation overlay">
      <div className="praxys-dictation-overlay-card">
        <div className="praxys-dictation-overlay-head">
          <span className="praxys-dictation-overlay-icon">
            {error ? <CloseOutlined /> : recording ? <AudioOutlined /> : <LoadingOutlined spin />}
          </span>
          <div>
            <div className="praxys-dictation-overlay-title">{title}</div>
            <div className="praxys-dictation-overlay-subtitle">{subtitle}</div>
          </div>
        </div>

        {!error && <WaveIndicator active={recording} className="praxys-dictation-overlay-wave" />}

        {transcript && (
          <div className="praxys-dictation-overlay-transcript" aria-live="polite">
            {transcript}
          </div>
        )}

        <div className="praxys-dictation-overlay-actions">
          {!error && recording && (
            <button className="praxys-dictation-overlay-stop" onClick={onStop}>
              <StopOutlined /> Stop
            </button>
          )}
          <button className="praxys-dictation-overlay-cancel" onClick={onCancel}>
            {error ? 'Close' : 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DictationOverlay;
